export const home = {
    hero: {
        badge: 'Leading Drone Technology',
        title: {
            line1: 'Drone Solutions',
            line2: 'for Agriculture',
        },
        description: 'We offer high-quality professional drones and specialized technical assistance for agricultural drones. Cutting-edge technology to maximize your productivity.',
        features: {
            feature1: 'Certified professional drones',
            feature2: 'Specialized technical assistance',
            feature3: 'Complete technical support',
        },
        cta: {
            primary: 'View Catalog',
            secondary: 'Contact Us',
        },
        image: {
            alt: 'Professional drone for agriculture',
        },
    },
    footer: {
        company: {
            name: 'Fronteira Sul Drones',
            description: 'Specialists in professional drones and technical assistance for agricultural drones. We offer cutting-edge technology, specialized maintenance, and customized solutions to maximize your business productivity.',
        },
        badges: {
            experience: 'Years of Experience',
            quality: 'Quality Guaranteed',
        },
        sections: {
            quickLinks: 'Quick Links',
            contact: 'Contact',
        },
        links: {
            home: 'Home',
            newDrones: 'New Drones',
            usedDrones: 'Used Drones',
            services: 'Services',
            about: 'About',
            contact: 'Contact',
        },
        contact: {
            hours: {
                weekdays: 'Monday to Friday: {{start}} to {{end}}',
                saturday: 'Saturday: {{start}} to {{end}}',
            },
        },
        copyright: '© {{year}} Fronteira Sul Drones. All rights reserved.',
        madeBy: {
            label: 'Made by',
            ariaLabel: 'Made by AttoDev',
        },
    },
    about: {
        badge: 'About Us',
        title: {
            part1: 'Meet',
            part2: 'Fronteira Sul Drones',
        },
        description: {
            paragraph1: 'Fronteira Sul Drones is a company specialized in technological solutions for agriculture, offering high-quality professional drones and specialized technical assistance for agricultural drones.',
            paragraph2: 'With years of experience in agricultural spraying drones, our mission is to provide cutting-edge technology that maximizes our clients productivity and efficiency, always prioritizing quality, safety, and innovation.',
            paragraph3: 'We work with certified equipment and a highly qualified team, ensuring exceptional results in every project.',
        },
        values: {
            title: 'Our Values',
            quality: 'Quality',
            innovation: 'Innovation',
            reliability: 'Reliability',
            excellence: 'Excellence',
        },
    },
    newDrones: {
        badge: 'Professional Grade',
        title: 'New Drones',
        subtitle: 'Cutting-edge technology for your needs',
        viewCatalog: 'View Full Catalog',
        features: 'Features',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        noProducts: 'We currently have no new drones available. Please check back soon or contact us.',
    },
    usedDrones: {
        badge: 'Verified Opportunity',
        title: 'Used Drones',
        subtitle: 'Guaranteed quality with best value',
        viewCatalog: 'View Full Catalog',
        condition: 'Condition',
        features: 'Features',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        noProducts: 'We currently have no used drones available. Check our new drones catalog.',
    },
    buffalo: {
        badge: 'Engines and Coupled Products',
        title: 'Buffalo Line',
        subtitle: 'Excellence in engines and solutions for all of Brazil',
        viewCatalog: 'View Buffalo Line Catalog',
        noProducts: 'Buffalo Line products will be available in our catalog soon.',
    },
    powerCitros: {
        badge: 'Citrus Ultra Cleaner',
        title: 'Power Citros',
        subtitle: 'The only product you need to clean everything — drones, vehicles, agricultural equipment and more. High-performance biodegradable formula.',
        viewCatalog: 'View Power Citros Products',
        noProducts: 'Power Citros products will be available in our catalog soon.',
    },
    parts: {
        badge: 'Original Parts',
        title: 'Parts and Accessories',
        subtitle: 'Find the best original parts and accessories for your equipment',
        viewCatalog: 'View Parts Catalog',
        noProducts: 'Parts will be available in our online catalog soon.',
    },
    spraying: {
        badge: 'Specialized Services',
        title: {
            part1: 'Technical Assistance and Maintenance',
            part2: 'for Agricultural Drones',
        },
        subtitle: 'Specialized technical assistance and maintenance services for agricultural drones. Qualified team and original parts to ensure maximum performance of your equipment.',
        description: {
            paragraph1: 'We offer complete technical assistance and preventive and corrective maintenance services for agricultural drones, focusing on keeping your equipment always in perfect working condition.',
            paragraph2: 'Our team consists of highly qualified technicians with extensive experience in agricultural drones and certifications to work with state-of-the-art equipment.',
            paragraph3: 'We work with original parts, perform accurate diagnostics, and offer complete technical support to maximize the lifespan and performance of your drones.',
        },
        benefits: {
            title: 'Benefits',
            precision: 'Accurate Diagnosis',
            efficiency: 'Fast Maintenance',
            safety: 'Original Parts',
            technology: 'Certified Technicians',
        },
        services: {
            title: 'Our Services',
            mapping: 'Preventive maintenance and complete periodic inspections',
            calibration: 'Calibration and configuration of spraying systems and sensors',
            application: 'Repair and replacement of parts with original components',
            support: 'Specialized technical support and operator training',
        },
        equipment: {
            title: 'Equipment',
            description: 'We use XAG P100 Pro drones with RTK technology, ensuring precision and efficiency in all operations.',
            certified: 'MAPA Certified',
        },
        cta: {
            button: 'Request Quote',
            description: 'Contact us and request a personalized quote for your property',
        },
    },
    metrics: {
        title: 'Our Numbers',
        subtitle: 'Results that prove our experience and commitment to excellence in agribusiness',
        hectares: 'Hectares Sprayed',
        clients: 'Clients Served',
        experience: 'Years of Experience',
        drones: 'Operational Drones',
        economy: 'Defensive Savings',
        precision: 'Application Precision',
        suffix: {
            hectares: '+ ha',
            clients: '+',
            years: ' years',
            drones: ' units',
            economy: '%',
            precision: '%',
        },
    },
    contact: {
        badge: 'Get in Touch',
        title: 'Contact Us',
        subtitle: 'We are ready to help you find the best drone solution',
        whatsapp: {
            title: 'WhatsApp',
            description: 'Talk to us directly on WhatsApp',
            button: 'Chat on WhatsApp',
            cta: 'Quick response and personalized service',
        },
        other: {
            title: 'Other Contact Methods',
            email: {
                label: 'Email',
            },
            phone: {
                label: 'Phone',
            },
            address: {
                label: 'Address',
            },
            hours: {
                label: 'Business Hours',
            },
        },
    },
    productCard: {
        featured: 'Featured',
        buy: 'Buy Now',
        types: {
            new: 'Pro Edition',
            used: 'Verified Quality',
            buffalo: 'Buffalo Line',
            'power-citros': 'Power Citros',
            parts: 'Original Part',
        },
    },
};
//# sourceMappingURL=home.js.map